import RelationshipMetadata from "../../RelationshipMetadata";

class AdminRoleAdminRoleChildRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminRoleAdminRoleRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminRole";
        this.childEnterpriseComponent = "AdminRoleChild";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ChildRoleUSID";
    }
}

export default AdminRoleAdminRoleChildRelationshipMetadata;